import { Fetch } from '../fetch';
import { RequestFindAll } from '../requests';
import { ResponseFailure, ResponseSuccess } from '../responses';

export const RequestFindAllFieldMapping = (
	params: RequestFindAll
): Promise<ResponseSuccess<any> | ResponseFailure> =>
	Fetch(RequestFindAllFieldMapping.name, 'api/common/field-mapping', params);
